import { css } from 'styled-components';
/**
 * @see {@link https://glassmorphism.com/}
 * @example set parent background color to #7DA0DE
 */
/* background-color: ${() => rgba(cssVar('--bg-color'), 0.85)}; */
export const blur = css `
  background-color: ${() => 'var(--blur-bg-color)'};
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
`;
export const dropShadowLarge = css `
  filter: drop-shadow(0px 20px 30px rgba(0, 0, 0, 0.2));
`;
